import { getMaxOrganizationsPerAccount } from '../../../../backend/utils/getMaxOrganizationsPerAccount';
import { AuthError } from '@juvare/platform-app/App';
export function getDisplayName(firstName, lastName) {
    return [firstName, lastName].filter((name) => !!name).join(' ');
}
export function trimStringValue(value) {
    return value ? value.trim() : '';
}
export function getAccountDisplayName(account) {
    return getDisplayName(account.firstName, account.lastName);
}
export function isLoginEmailExistInContactInformation(data) {
    var _a;
    return (_a = data.contactEmails) === null || _a === void 0 ? void 0 : _a.some((contactEmail) => {
        return contactEmail.email === data.email;
    });
}
export function trimOrganizationPath(path) {
    const pathArray = path.split('/');
    const trimmedPathArray = [];
    pathArray.forEach((path) => {
        trimmedPathArray.push(path.trim());
    });
    return trimmedPathArray.join('/');
}
export function getAssignableOrganizationsCount(orgStatus, appState) {
    var _a;
    let assignableOrgCount = 0;
    for (const status of Object.values(orgStatus || {})) {
        if ((_a = appState.settings.orgStatusMap[status]) === null || _a === void 0 ? void 0 : _a.appliesToMaxOrganizationsPerAccount) {
            assignableOrgCount++;
        }
    }
    return assignableOrgCount;
}
export function validateMaxOrganizationsPerAccount(orgStatus, appState) {
    const maxOrganizationsPerAccount = getMaxOrganizationsPerAccount(appState.settings);
    if (maxOrganizationsPerAccount) {
        const assignableOrganizationsCount = getAssignableOrganizationsCount(orgStatus, appState);
        if (assignableOrganizationsCount > maxOrganizationsPerAccount) {
            throw new AuthError('This account has reached the maximum number of accepted and pending organization memberships. A membership must be removed to add a new one.');
        }
    }
}
/**
 * Builds a map of organization roles from an array of strings in the format "orgId_role".
 * The resulting map will have the organization ID as the key and the role as the value.
 */
export function buildOrgRolesMap(orgRoles) {
    return orgRoles.reduce((orgRoleMap, orgRoleString) => {
        const [orgId, orgRole] = orgRoleString.split('_');
        orgRoleMap[orgId] = orgRole;
        return orgRoleMap;
    }, {});
}
/**
 * Builds a map of organization statuses from an array of strings in the format "orgId_status".
 * The resulting map will have the organization ID as the key and the status as the value.
 */
export function buildOrgStatusesMap(orgStatuses) {
    return orgStatuses.reduce((orgStatusMap, orgStatusString) => {
        const [orgId, orgStatus] = orgStatusString.split('_');
        orgStatusMap[orgId] = orgStatus;
        return orgStatusMap;
    }, {});
}
